__turbopack_context__.v({
  "numberedList": "IGFRrG_numberedList",
  "whySection": "IGFRrG_whySection",
});
